export const GtmEvent = {
  USER_SESSION_START: "user_session_start",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  REMOVE_FROM_CART: "remove_from_cart",
  ADD_TO_WISHLIST: "add_to_wishlist",
  REMOVE_FROM_WISHLIST: "remove_from_wishlist",
  SUBSCRIBE_BACK_IN_STOCK: "subscribe_back_in_stock",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
  ORDER_SUBMISSION_ERROR: "order_submission_error",
};

export const EVENT_KEYS = Object.values(GtmEvent);
